import clsx from "clsx";
import React, { useMemo } from "react";
import { PageType, SingularPage } from "../../../../types";

interface IconButtonProps {
  className?: string;
  active?: boolean;
  onClick: () => void;
  page: SingularPage;
  showMobile: boolean;
}

export function IconButton({
  active,
  onClick,
  page,
  showMobile,
}: IconButtonProps) {
  const bgStyle = useMemo(() => {
    return {
      "bg-catalog-evidence": page.type === PageType.evidence && active,
      "bg-catalog-method": page.type === PageType.method && active,
      "bg-catalog-notes": page.type === PageType.notes && active,
      "bg-catalog-science": page.type === PageType.science && active,
    };
  }, [page.type, active]);

  const hoverStyle = useMemo(() => {
    return {
      "hover:bg-catalog-evidence": page.type === PageType.evidence,
      "hover:bg-catalog-method": page.type === PageType.method,
      "hover:bg-catalog-notes": page.type === PageType.notes,
      "hover:bg-catalog-science": page.type === PageType.science,
    };
  }, [page.type]);

  return (
    <button
      className={clsx("w-full flex  ", {
        "flex-row": showMobile,
        "flex-col": !showMobile,
      })}
      onClick={onClick}
    >
      <div
        className={clsx("p-6 transition duration-500", {
          "p-[16px]": active,
          "hidden ": showMobile,
          "flex ": !showMobile
        })}
      >
        <div
          className={clsx(
            `bg-[#d1d1d1] overflow-hidden rounded-full p-4 transition-all duration-500`,
            hoverStyle,
            bgStyle
          )}
        >
          {page.type === PageType.notes && (
            <img
              src={require("../../../../assets/icons/criterias/notes.png")}
              className="w-full h-full"
              alt="noter"
            />
          )}
          {page.type === PageType.method && (
            <img
              src={require("../../../../assets/icons/criterias/method.png")}
              className="w-full h-full"
              alt="metode"
            />
          )}
          {page.type === PageType.science && (
            <img
              src={require("../../../../assets/icons/criterias/science.png")}
              className="w-full h-full"
              alt="videnskab"
            />
          )}
          {page.type === PageType.evidence && (
            <img
              src={require("../../../../assets/icons/criterias/evidens.png")}
              className="w-full h-full"
              alt="evidens"
            />
          )}
        </div>
      </div>
      <div className={clsx("justify-center items-center", {
        "flex ": showMobile,
        "hidden ": !showMobile
      })}>
        <div
          className={clsx(
            " flex h-6 w-6 bg-[#d1d1d1] rounded-full mr-1.5",
            bgStyle,
            hoverStyle
          )}
        />
      </div>
      <p className="text-lg w-full">{page.title}</p>
    </button>
  );
}
